import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './BillReduction.module.css';

const BillReduction = () => {
    return (
        <div className={css.billReductionPage}>
            <div className={css.breadcrumb}>
                <span>
                    <FormattedMessage id="BillReductionPage.breadcrumbDashboard" />
                </span>
                <span className={css.breadcrumbSeparator}>/</span>
                <span className={css.breadcrumbCurrent}>
                    <FormattedMessage id="BillReductionPage.breadcrumbCurrent" />
                </span>
            </div>

            <div className={css.header}>
                <div className={css.headerContent}>
                    <h1 className={css.title}>
                        <FormattedMessage id="BillReductionPage.title" />
                    </h1>
                    <p className={css.subtitle}>
                        <FormattedMessage id="BillReductionPage.subtitle" />
                    </p>
                </div>
                <span className={css.statusPill}>
                    <FormattedMessage id="BillReductionPage.statusPill" />
                </span>
            </div>

            <div className={css.alert}>
                <div className={css.alertLeft}>
                    <span className={css.alertIcon}>!</span>
                    <div className={css.alertText}>
                        <p className={css.alertTitle}>
                            <FormattedMessage id="BillReductionPage.alertTitle" />
                        </p>
                        <p className={css.alertSubtitle}>
                            <FormattedMessage id="BillReductionPage.alertSubtitle" />
                        </p>
                    </div>
                </div>
                <div className={css.alertRight}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10.0013 1.6665C14.6038 1.6665 18.3346 5.39734 18.3346 9.99984C18.3346 14.6023 14.6038 18.3332 10.0013 18.3332C5.3988 18.3332 1.66797 14.6023 1.66797 9.99984C1.66797 5.39734 5.3988 1.6665 10.0013 1.6665ZM10.0013 4.99984C9.78029 4.99984 9.56833 5.08764 9.41205 5.24392C9.25577 5.4002 9.16797 5.61216 9.16797 5.83317V9.99984C9.16802 10.2208 9.25584 10.4328 9.41214 10.589L11.9121 13.089C12.0693 13.2408 12.2798 13.3248 12.4983 13.3229C12.7168 13.321 12.9258 13.2334 13.0803 13.0789C13.2348 12.9243 13.3225 12.7153 13.3244 12.4968C13.3263 12.2783 13.2423 12.0678 13.0905 11.9107L10.8346 9.65484V5.83317C10.8346 5.61216 10.7468 5.4002 10.5906 5.24392C10.4343 5.08764 10.2223 4.99984 10.0013 4.99984Z" fill="#E69A2A" />
                    </svg>
                    <span className={css.alertTime}>
                        <FormattedMessage id="BillReductionPage.alertTime" />
                    </span>
                </div>
            </div>

            <div className={css.card}>
                <h3 className={css.cardTitle}>
                    <FormattedMessage id="BillReductionPage.eventTitle" />
                </h3>
                <div className={css.infoRow}>
                    <div className={css.infoItem}>
                        <span className={css.infoLabel}>
                            <FormattedMessage id="BillReductionPage.eventIdLabel" />
                        </span>
                        <span className={css.infoValue}>
                            <FormattedMessage id="BillReductionPage.eventIdValue" />
                        </span>
                    </div>
                    <div className={css.infoItem}>
                        <span className={css.infoLabel}>
                            <FormattedMessage id="BillReductionPage.eventDateLabel" />
                        </span>
                        <span className={css.infoValue}>
                            <FormattedMessage id="BillReductionPage.eventDateValue" />
                        </span>
                    </div>
                    <div className={css.infoItem}>
                        <span className={css.infoLabel}>
                            <FormattedMessage id="BillReductionPage.companyLabel" />
                        </span>
                        <span className={css.infoValue}>
                            <FormattedMessage id="BillReductionPage.companyValue" />
                        </span>
                    </div>
                    <div className={css.infoItem}>
                        <span className={css.infoLabel}>
                            <FormattedMessage id="BillReductionPage.reductionRateLabel" />
                        </span>
                        <span className={css.infoValue}>
                            <FormattedMessage id="BillReductionPage.reductionRateValue" />
                        </span>
                    </div>
                </div>
            </div>

            <div className={css.card}>
                <h3 className={css.cardTitle}>
                    <FormattedMessage id="BillReductionPage.servicesTitle" />
                </h3>
                <div className={css.servicesBox}>
                    <div className={css.servicesHeader}>
                        <FormattedMessage id="BillReductionPage.servicesHeader" />
                    </div>
                    <div className={css.servicesRow}>
                        <b>
                            <FormattedMessage id="BillReductionPage.serviceItemRoaming" />
                        </b>
                        <span>
                            <FormattedMessage id="BillReductionPage.servicePriceRoaming" />
                        </span>
                    </div>
                    <div className={css.servicesRow}>
                        <b>
                            <FormattedMessage id="BillReductionPage.serviceItemDj" />
                        </b>
                        <span>
                            <FormattedMessage id="BillReductionPage.servicePriceDj" />
                        </span>
                    </div>
                    <div className={css.servicesRow}>
                        <b>
                            <FormattedMessage id="BillReductionPage.serviceItemOvertime" />
                        </b>
                        <span>
                            <FormattedMessage id="BillReductionPage.servicePriceOvertime" />
                        </span>
                    </div>
                    <div className={css.servicesRowTotal}>
                        <b>
                            <FormattedMessage id="BillReductionPage.servicesTotalLabel" />
                        </b>
                        <span>
                            <FormattedMessage id="BillReductionPage.servicesTotalValue" />
                        </span>
                    </div>
                </div>
            </div>

            <div className={`${css.card} ${css.billReductionCard}`}>
                <h3 className={css.billReductionTitle}>
                    <FormattedMessage id="BillReductionPage.billReductionTitle" />
                </h3>
                <div className={css.billReductionRate}>
                    <span className={css.billReductionLabel}>
                        <FormattedMessage id="BillReductionPage.billReductionRateLabel" />
                    </span>
                    <span className={css.billReductionValue}>
                        <FormattedMessage id="BillReductionPage.billReductionRateValue" />
                    </span>
                </div>
                <div className={css.reasonBox}>
                    <p className={css.reasonTitle}>
                        <FormattedMessage id="BillReductionPage.reasonTitle" />
                    </p>
                    <p className={css.reasonText}>
                        <FormattedMessage id="BillReductionPage.reasonText" />
                    </p>
                    <p className={css.reasonMeta}>
                        <FormattedMessage id="BillReductionPage.reasonMeta" />
                    </p>
                </div>
            </div>

            <div className={css.card}>
                <h3 className={css.cardTitle}>
                    <FormattedMessage id="BillReductionPage.supportingDocumentsTitle" />
                </h3>
                <div className={css.documentRow}>
                    <div className={css.documentLeft}>
                        <span className={css.documentIcon} aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                <path d="M5.20833 21.875C4.63542 21.875 4.14514 21.6712 3.7375 21.2635C3.32986 20.8559 3.12569 20.3653 3.125 19.7917V5.20833C3.125 4.63542 3.32917 4.14514 3.7375 3.7375C4.14583 3.32986 4.63611 3.12569 5.20833 3.125H19.7917C20.3646 3.125 20.8552 3.32917 21.2635 3.7375C21.6719 4.14583 21.8757 4.63611 21.875 5.20833V19.7917C21.875 20.3646 21.6712 20.8552 21.2635 21.2635C20.8559 21.6719 20.3653 21.8757 19.7917 21.875H5.20833ZM6.25 17.7083H18.75L14.8438 12.5L11.7188 16.6667L9.375 13.5417L6.25 17.7083Z" fill="#6939CB" />
                            </svg>
                        </span>
                        <div className={css.documentText}>
                            <p className={css.documentName}>
                                <FormattedMessage id="BillReductionPage.documentName" />
                            </p>
                            <p className={css.documentMeta}>
                                <FormattedMessage id="BillReductionPage.documentMeta" />
                            </p>
                        </div>
                    </div>
                    <button type="button" className={css.documentView}>
                        <FormattedMessage id="BillReductionPage.documentView" />
                    </button>
                </div>
            </div>

            <div className={css.card}>
                <div className={css.totalRow}>
                    <div>
                        <h3 className={css.totalTitle}>
                            <FormattedMessage id="BillReductionPage.totalTitle" />
                        </h3>
                        <p className={css.totalSubtitle}>
                            <FormattedMessage id="BillReductionPage.totalSubtitle" />
                        </p>
                    </div>
                    <div className={css.totalAmount}>
                        <FormattedMessage id="BillReductionPage.totalAmount" />
                    </div>
                </div>
                <div className={css.totalButtons}>
                    <button type="button" className={`${css.actionButton} ${css.disputeButton}`}>
                        <FormattedMessage id="BillReductionPage.disputeButton" />
                    </button>
                    <button type="button" className={`${css.actionButton} ${css.acceptButton}`}>
                        <FormattedMessage id="BillReductionPage.acceptButton" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BillReduction;